import React, { useState, useEffect } from 'react'
import TextField from '../Textfield';
import { useIntl } from 'react-intl';
import { ProductInputDataRequiredFields } from '../../redux/product/productTypes';
import { Grid, Divider } from '@material-ui/core';
import isFieldEmpty from '../../service/IsFieldEmpty';

interface Props {
    inputChanged(event: any): any,
    torque?: number | null,
    axialForce?: number | null,
    rotationSpeed?: number | null,
    errorFields?: ProductInputDataRequiredFields,
    hubOuterDiameter?: number | null,
    hubInnerDiameter_D?:number | null
}
export const Basicdata: React.FC<Props> = (props) => {
    const [rotationSpeedFieldEnter, setRotationSpeedFieldEnter] = useState<boolean>();
    const [rimSpeed, setRimSpeed] = useState(0);

    
    // eslint-disable-next-line
    useEffect(() => {
        // Berechnen der Maximal zulässigen Umfangsgeschwindigkeit
        //console.log("rotation speed",props.rotationSpeed);
        //console.log("hub outer diameter",props.hubOuterDiameter);
        
        if (props.hubOuterDiameter !== null && props.rotationSpeed !== null &&
            props.hubOuterDiameter !== undefined && props.rotationSpeed !== undefined)
            {
                setRimSpeed(Math.PI * (props.hubOuterDiameter / 1000) * (props.rotationSpeed / 60));
                console.log("RIM Speed:" ,Math.PI * (props.hubOuterDiameter / 1000) * (props.rotationSpeed / 60))
            }
    },[props.rotationSpeed])

    function checkIfRotationSpeedError(): boolean {
        // HubOuterdiameter muss immer größer sein als hubInnerDiameter!
        // Außerdem wird hier noch geprüft der Cursor gerade in der Texbox ist. Wenn nicht soll die Fehlermeldung auch nicht angezeigt werden

        //if (rimSpeed > 40 && rotationSpeedFieldEnter)
        if (rimSpeed >= 40)
            return true;
        //Hier wird geprüft ob dieses Feld im Redux store unter errorfields aufgeführt ist und das Feld null (leer ist). 
        // Diese condition ist dafür, dass die Fehlermeldung verschwindet sobald Zahlen in die textbox eingetippt werden.
        else if (props.errorFields !== undefined && props.errorFields.rotationSpeed && isFieldEmpty(props.rotationSpeed))
            return true;
        else
            //wenn beides falsch ist wird der wert des Error fields ausgegeben und wenn dieser nicht definiert ist -> False
            return false; //(props.errorFields !== undefined && props.errorFields.rotationSpeed) || false;
    }  

    const { formatMessage: f } = useIntl();
    return (
        //<Panel title={f({ id: 'app.containerBasicLabel' })} className={classes.basicDataPanel}>
        <Grid xs={12} item style={{marginTop: "20px"}}>
            <b>{f({ id: 'app.containerBasicLabel.Application' })}</b>
            <Divider></Divider>
            <form >
                <TextField
                    error={props.errorFields !== undefined && props.errorFields.torque && isFieldEmpty(props.torque)}
                    errorText={f({ id: 'app.error.required', defaultMessage: 'Required' })}
                    type="number"
                    value={props.torque === null ? "" : props.torque}
                    onChange={e => props.inputChanged({ torque: e.target.value === "" ? null : Number(e.target.value) })}
                    labelBefore={<span>{f({ id: 'app.labelDrehmom', defaultMessage: 'Torque' })} T<sub>{f({ id: 'app.eingabeTiefgestellt' })}</sub></span>}
                    labelAfter="Nm" />

                <TextField
                       error={props.errorFields !== undefined && props.errorFields.axialForce && isFieldEmpty(props.axialForce)}
                    errorText={f({ id: 'app.error.required', defaultMessage: 'Required' })}
                    type="number"
                    value={props.axialForce === null ? "" : props.axialForce}
                    onChange={e => props.inputChanged({ axialForce: e.target.value === "" ? null : Number(e.target.value) })}
                    labelBefore={<span>{f({ id: 'app.labelAxialkraft', defaultMessage: 'Axial force' })} F<sub>ax {f({ id: 'app.basicdata.application', defaultMessage: 'app' })}</sub></span>}
                    labelAfter="kN" />

                <TextField
                    error={checkIfRotationSpeedError()}
                    type="number"
                    errorText={
                        //wenn die Range Speed größer 40 ist, und ich aktuell im Feld rotation Speed steht, dann zeige die Fehlermeldung rotation speed an, wenn nicht zeige an, dass das Feld required ist
                        rimSpeed > 40 && rotationSpeedFieldEnter ?
                            f({ id: 'app.error.maxRangeSpeedExeeded', defaultMessage: 'Have to be bigger then D.' }) : f({ id: 'app.error.required', defaultMessage: 'Required' })
                    }
                    value={props.rotationSpeed === null ? "" : props.rotationSpeed}
                    onChange={e => {
                        props.inputChanged({ rotationSpeed: e.target.value === "" ? null : Number(e.target.value) });
                        setRotationSpeedFieldEnter(true);
                    }}
                    labelBefore={<span>{f({ id: 'app.labelDrehzahl', defaultMessage: 'Revolution speed' })} n<sub>{f({ id: 'app.basicdata.application', defaultMessage: 'app' })}</sub></span>}
                    labelAfter="1/min" />
            </form>
        </Grid>
      //  </Panel>
    )
}

export default Basicdata;